import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';
import {microsoftAuthApiRef} from "@backstage/core-plugin-api";
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';


const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      (
        <SignInPage
          {...props}
          provider={{
            id: 'microsoft-auth-provider',
            title: 'Azure',
            message: 'Sign in using Objective ID',
            apiRef: microsoftAuthApiRef,
          }}
        />
      ),
  },
});


export default createApp({
  features: [catalogPlugin, 
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
    ],
});


